import { animated, useTransition } from '@react-spring/web';
import clsx from 'clsx';
import React, { FC } from 'react';
import { useToastStore } from '../../store';
import { ThemeSignalColor } from '../../theme';
import { Stack } from '../stack';
import { Toast } from '../toast';
import { ToastVariant } from '../toast/types';
import classes from './toast-stack.module.scss';

const VARIANT_COLOR_MAP: Record<ToastVariant, ThemeSignalColor> = {
  success: 'success',
  error: 'danger',
  info: 'info',
  warning: 'warning',
};

/**
 * This component has the purpose to render the toasts which are stored within the ToastStore
 */
export const ToastStack: FC = () => {
  const toasts = useToastStore(state => state.toast);
  const remove = useToastStore(state => state.remove);

  const transitions = useTransition(toasts, {
    from: { opacity: 0, transform: 'translateY(-20px)' },
    enter: { opacity: 1, transform: 'translateY(0px)' },
    leave: { opacity: 0, transform: 'translateY(-20px)' },
    keys: toasts.map(item => item.id),
  });

  return (
    <div className={clsx('toast-stack-component', classes.root)}>
      <Stack direction="column" crossAxis="end">
        {transitions(({ ...style }, item) => (
          <animated.div key={item.id} style={style} className={classes.toastWrapper}>
            <Toast
              className={classes.toast}
              key={item.id}
              title={item.title}
              color={VARIANT_COLOR_MAP[item.variant]}
              onClose={() => remove(item.id)}
            >
              {item.text}
            </Toast>
          </animated.div>
        ))}
      </Stack>
    </div>
  );
};
